import { render, staticRenderFns } from "./LastCard.vue?vue&type=template&id=3bf5eae8&"
import script from "./LastCard.vue?vue&type=script&lang=js&"
export * from "./LastCard.vue?vue&type=script&lang=js&"
import style0 from "./LastCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports